/**
 * mc-bundle-cervejas.js — Manifesto (tasks 0026 + 0028)
 *
 * Interatividade da PDP de bundle (main-product-bundle-cervejas):
 *   1. Galeria — thumbnail troca a imagem principal (delegação no root,
 *      cobre thumbs server-side E thumbs injetados pela hidratação).
 *   2. CTA dinâmico — "Adicionar pack — R$X" acompanha a quantidade,
 *      usando o template i18n do markup (data-str-add-template, %PRICE%).
 *   3. "N packs no carrinho" — pub/sub 'cart-update' do Dawn.
 *   4. Barra fixa mobile (padrão task 0025): aparece quando o bloco de preço
 *      sai da tela (IntersectionObserver), stepper espelha o qty da página.
 *   5. HIDRATAÇÃO VIA APP (task 0028, decisão do dono 2026-07-21): sem
 *      metaobjects, o conteúdo do pack vem dos componentes registrados no
 *      próprio app Shopify Bundles, lidos da Storefront API
 *      (variant.components — o Liquid não enxerga esse vínculo). O JS
 *      preenche lista/chip/riscado/R$-lata/tabela/thumbs nos mounts
 *      [hidden] do Liquid e revela. Regras:
 *        - Economia SÓ aparece se soma avulso > preço do pack (DP-3
 *          client-side — nunca inventa desconto).
 *        - Sem token/componentes/JS ⇒ nada revela; a página segue como PDP
 *          simples (falha por omissão).
 *        - Todo texto entra via textContent (nunca innerHTML com dado
 *          externo — higiene XSS).
 *
 * O add-to-cart é do <product-form> nativo (product-form.js) — inclusive o
 * botão da barra, que é submit EXTERNO via form=. A COMPRA não depende
 * deste script. Strings de UI vêm do Liquid via data-str-* (locale pt-BR);
 * templates plurais usam o sentinel 999 (data-str-many) e %A%/%P% para
 * valores.
 */

(function () {
  'use strict';

  var BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  var SF_API = '/api/2025-01/graphql.json';
  var SF_QUERY =
    'query($id:ID!){node(id:$id){... on ProductVariant{components(first:50){nodes{' +
    'quantity productVariant{id price{amount}product{title featuredImage{url}}}}}}}}';

  function money(cents) { return BRL.format(cents / 100); }

  function formatTemplate(template, cents) {
    return template.replace('%PRICE%', money(cents));
  }

  function pluralStr(el, n) {
    var one = el.getAttribute('data-str-one') || '';
    var many = el.getAttribute('data-str-many') || '';
    return n === 1 ? one : many.replace('999', String(n));
  }

  function imgUrl(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  /* ─── 1. Galeria (delegação — cobre thumbs injetados) ─── */
  function initGallery(root) {
    root.addEventListener('click', function (e) {
      var thumb = e.target.closest ? e.target.closest('[data-mc-bundle-thumb]') : null;
      if (!thumb || !root.contains(thumb)) return;
      var main = root.querySelector('[data-mc-bundle-main]');
      if (!main) return;
      var full = thumb.getAttribute('data-full');
      if (full) {
        main.removeAttribute('srcset');
        main.src = full;
      }
      root.querySelectorAll('[data-mc-bundle-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
    });
  }

  /* ─── 2. CTA dinâmico ─── */
  function initQtyTotal(root) {
    var qtyInput = root.querySelector('[data-mc-bundle-qty]');
    var priceEl = root.querySelector('[data-mc-bundle-unit-price]');
    if (!qtyInput || !priceEl) return;

    var unitCents = parseInt(priceEl.getAttribute('data-mc-bundle-unit-price'), 10) || 0;
    if (!unitCents) return;

    var targets = [];
    var addBtn = root.querySelector('.mc-bundle__add[data-str-add-template]');
    var addLabel = root.querySelector('[data-mc-bundle-add-label]');
    if (addBtn && addLabel && !addBtn.disabled) {
      targets.push({ el: addLabel, template: addBtn.getAttribute('data-str-add-template') });
    }
    var barBtn = root.querySelector('.mc-bundle-buybar__add[data-str-add-template]');
    var barLabel = root.querySelector('[data-mc-bundle-buybar-add-label]');
    if (barBtn && barLabel && !barBtn.disabled) {
      targets.push({ el: barLabel, template: barBtn.getAttribute('data-str-add-template') });
    }
    if (!targets.length) return;

    function render() {
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      var total = unitCents * qty;
      targets.forEach(function (t) {
        if (t.template) t.el.textContent = formatTemplate(t.template, total);
      });
    }

    qtyInput.addEventListener('change', render);
    qtyInput.addEventListener('input', render);
    render();
  }

  /* ─── 3. "N packs no carrinho" ─── */
  function initInCart(root) {
    var box = root.querySelector('[data-mc-bundle-in-cart]');
    if (!box) return;
    var variantId = box.getAttribute('data-variant-id');
    var strSingular = box.getAttribute('data-str-singular') || '';
    var strPlural = box.getAttribute('data-str-plural') || '';
    var countEl = box.querySelector('[data-mc-bundle-in-cart-count]');
    var suffixEl = box.querySelector('[data-mc-bundle-in-cart-suffix]');

    function apply(count) {
      if (countEl) countEl.textContent = String(count);
      if (suffixEl) suffixEl.textContent = count === 1 ? strSingular : strPlural;
      box.classList.toggle('is-hidden', count <= 0);
    }

    function refresh() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || !cart.items) return;
          var count = 0;
          cart.items.forEach(function (it) {
            if (String(it.variant_id) === String(variantId)) count += it.quantity;
          });
          apply(count);
        })
        .catch(function () {});
    }

    if (typeof window.subscribe === 'function') {
      window.subscribe('cart-update', refresh);
    }
  }

  /* ─── 4. Barra fixa mobile ─── */
  function initBuyBar(root) {
    var bar = root.querySelector('[data-mc-bundle-buybar]');
    if (!bar) return;

    var qtyInput = root.querySelector('[data-mc-bundle-qty]');

    var anchor = root.querySelector('[data-mc-bundle-buy-anchor]');
    if (anchor && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          bar.classList.toggle('is-visible', !e.isIntersecting);
        });
      }, { rootMargin: '0px 0px -25% 0px', threshold: 0 });
      obs.observe(anchor);
    } else {
      bar.classList.add('is-visible');
    }

    var barQty = bar.querySelector('[data-mc-bundle-buybar-qty]');
    var minus = bar.querySelector('[data-mc-bundle-buybar-minus]');
    var plus = bar.querySelector('[data-mc-bundle-buybar-plus]');

    function getQty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }
    function syncBar() {
      if (barQty) barQty.textContent = String(getQty());
    }
    function setQty(q) {
      q = Math.max(1, q);
      if (qtyInput) {
        qtyInput.value = q;
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      syncBar();
    }
    if (minus) minus.addEventListener('click', function () { setQty(getQty() - 1); });
    if (plus) plus.addEventListener('click', function () { setQty(getQty() + 1); });
    if (qtyInput) {
      qtyInput.addEventListener('input', syncBar);
      qtyInput.addEventListener('change', syncBar);
    }
    syncBar();
  }

  /* ─── 5. Hidratação via app Shopify Bundles (task 0028) ─── */
  function initAppHydration(root) {
    if (root.getAttribute('data-app-hydrate') !== 'true') return;
    var token = (root.getAttribute('data-storefront-token') || '').trim();
    var gid = root.getAttribute('data-variant-gid');
    var packPrice = parseInt(root.getAttribute('data-price'), 10) || 0;
    // Numero de CERVEJAS declarado no Admin (custom.pack_units, task 0039).
    // Manda na contagem exibida, para que a lista nao contradiga o eyebrow
    // server-side. 0 = nao declarado, cai na soma dos componentes.
    var packUnits = parseInt(root.getAttribute('data-pack-units'), 10) || 0;
    if (!token || !gid || !packPrice) return;

    // No theme dev (127.0.0.1:9292) o proxy do CLI pode não repassar o
    // endpoint /api/* — em falha, repete UMA vez contra o domínio canônico
    // da loja (window.Shopify.shop; a Storefront API aceita cross-origin
    // por design). Em produção a chamada relativa resolve de primeira.
    function sfFetch(endpoint) {
      return fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({ query: SF_QUERY, variables: { id: gid } })
      }).then(function (r) {
        if (!r.ok) throw new Error('sf http ' + r.status);
        return r.json();
      });
    }

    sfFetch(SF_API)
      .catch(function () {
        var shop = window.Shopify && window.Shopify.shop;
        if (!shop) return null;
        return sfFetch('https://' + shop + SF_API).catch(function () { return null; });
      })
      .then(function (data) {
        var node = data && data.data && data.data.node;
        var nodes = node && node.components && node.components.nodes;
        if (!nodes || !nodes.length) return;

        var items = [];
        nodes.forEach(function (n) {
          var v = n.productVariant;
          if (!v) return;
          items.push({
            qty: Math.max(1, n.quantity || 1),
            title: (v.product && v.product.title) || '',
            img: (v.product && v.product.featuredImage && v.product.featuredImage.url) || '',
            price: Math.round(parseFloat((v.price && v.price.amount) || '0') * 100)
          });
        });
        if (!items.length) return;
        renderAppData(root, items, packPrice, packUnits);
      })
      .catch(function () {});
  }

  function renderAppData(root, items, packPrice, packUnits) {
    var cans = 0;
    var sum = 0;
    items.forEach(function (it) {
      cans += it.qty;
      sum += it.price * it.qty;
    });
    // Contagem EXIBIDA (task 0039): custom.pack_units quando declarado, senão
    // a soma dos componentes. `sum` continua somando TODOS os componentes —
    // o comparativo de economia não mudou.
    var shownCount = packUnits > 1 ? packUnits : cans;
    // DP-3 client-side: economia só existe se a soma dos avulsos REAIS
    // superar o preço do pack; preço zerado invalida o comparativo.
    var pricesOk = items.every(function (it) { return it.price > 0; });
    var showCompare = pricesOk && sum > packPrice;
    var pct = showCompare ? Math.round(((sum - packPrice) * 100) / sum) : 0;

    // Eyebrow (contagem de latas) — badge do hero removido a pedido do dono
    var eyebrow = root.querySelector('[data-mc-bundle-eyebrow]');
    if (eyebrow && shownCount > 0) {
      eyebrow.textContent = (eyebrow.getAttribute('data-prefix') || '') + pluralStr(eyebrow, shownCount);
    }

    // O preço por unidade NÃO é mais hidratado aqui (task 0039): ele é
    // server-side, vem de custom.pack_units e usa a mesma receita do card.
    // Dividir o preço pela soma dos componentes contava a taça de brinde como
    // unidade e fazia a PDP divergir da listagem.

    // Chip + riscado (buy-box) + barra mobile
    if (showCompare) {
      var chip = root.querySelector('[data-mc-bundle-app-chip]');
      if (chip) {
        chip.textContent = (chip.getAttribute('data-str-template') || '')
          .replace('%A%', money(sum - packPrice))
          .replace('%P%', String(pct));
        chip.removeAttribute('hidden');
      }
      var comp = root.querySelector('[data-mc-bundle-app-compare]');
      if (comp) {
        comp.textContent = (comp.getAttribute('data-str-template') || '%A%').replace('%A%', money(sum));
        comp.removeAttribute('hidden');
      }
      var bbCompare = root.querySelector('[data-mc-bundle-app-bb-compare]');
      if (bbCompare) {
        bbCompare.textContent = money(sum);
        bbCompare.removeAttribute('hidden');
      }
      var bbSave = root.querySelector('[data-mc-bundle-app-bb-save]');
      if (bbSave) {
        bbSave.textContent = '↓ ' + pct + '%';
        bbSave.removeAttribute('hidden');
      }
    }

    // Lista "O que vem no pack"
    var pack = root.querySelector('[data-mc-bundle-app-pack]');
    var list = root.querySelector('[data-mc-bundle-app-pack-list]');
    if (pack && list) {
      items.forEach(function (it) {
        var li = document.createElement('li');
        li.className = 'mc-bundle__pack-item';
        if (it.img) {
          var im = document.createElement('img');
          im.className = 'mc-bundle__pack-thumb';
          im.src = imgUrl(it.img, 120);
          im.alt = '';
          im.width = 44;
          im.height = 66;
          im.loading = 'lazy';
          li.appendChild(im);
        }
        var body = document.createElement('div');
        body.className = 'mc-bundle__pack-body';
        var name = document.createElement('span');
        name.className = 'mc-bundle__pack-name';
        name.textContent = it.title;
        body.appendChild(name);
        li.appendChild(body);
        if (showCompare) {
          var solo = document.createElement('s');
          solo.className = 'mc-bundle__pack-solo';
          solo.textContent = money(it.price);
          li.appendChild(solo);
        }
        var qty = document.createElement('span');
        qty.className = 'mc-bundle__pack-qty';
        qty.textContent = '× ' + it.qty;
        li.appendChild(qty);
        list.appendChild(li);
      });
      var cnt = root.querySelector('[data-mc-bundle-app-pack-count]');
      if (cnt) cnt.textContent = pluralStr(cnt, shownCount);
      pack.removeAttribute('hidden');
    }

    // Thumbs dos componentes na galeria + hero fallback (produto sem foto)
    if (root.getAttribute('data-show-thumbs') === 'true') {
      var wrap = root.querySelector('[data-mc-bundle-thumbs]');
      if (wrap) {
        items.forEach(function (it) {
          if (!it.img) return;
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'mc-bundle__thumb';
          btn.setAttribute('data-mc-bundle-thumb', '');
          btn.setAttribute('data-full', imgUrl(it.img, 900));
          btn.setAttribute('aria-label', it.title);
          var im = document.createElement('img');
          im.src = imgUrl(it.img, 160);
          im.alt = '';
          im.width = 72;
          im.height = 72;
          im.loading = 'lazy';
          btn.appendChild(im);
          wrap.appendChild(btn);
        });
        if (wrap.children.length > 0) wrap.removeAttribute('hidden');
      }
      var main = root.querySelector('[data-mc-bundle-main]');
      if (!main) {
        var heroWrap = root.querySelector('[data-mc-bundle-hero-wrap]');
        var first = null;
        items.some(function (it) { if (it.img) { first = it; return true; } return false; });
        if (heroWrap && first) {
          while (heroWrap.firstChild) heroWrap.removeChild(heroWrap.firstChild);
          var hero = document.createElement('img');
          hero.className = 'mc-bundle__hero-img';
          hero.setAttribute('data-mc-bundle-main', '');
          hero.src = imgUrl(first.img, 900);
          hero.alt = first.title;
          hero.width = 900;
          hero.height = 900;
          heroWrap.appendChild(hero);
        }
      }
    }

    // Tabela "A conta, lata a lata" (só com economia real)
    var tableBlock = root.querySelector('[data-mc-bundle-app-table]');
    if (tableBlock && showCompare) {
      var totalRow = tableBlock.querySelector('[data-mc-bundle-app-total-row]');
      if (totalRow) {
        items.forEach(function (it) {
          var row = document.createElement('div');
          row.className = 'mc-bundle__table-row';
          row.setAttribute('role', 'row');
          var c1 = document.createElement('span');
          c1.setAttribute('role', 'cell');
          var nm = document.createElement('span');
          nm.className = 'mc-bundle__table-name';
          nm.textContent = it.title;
          if (it.qty > 1) {
            var qq = document.createElement('span');
            qq.className = 'mc-bundle__table-qty';
            qq.textContent = ' × ' + it.qty;
            nm.appendChild(qq);
          }
          c1.appendChild(nm);
          row.appendChild(c1);
          var c2 = document.createElement('span');
          c2.className = 'mc-bundle__table-num mc-bundle__table-solo';
          c2.setAttribute('role', 'cell');
          c2.textContent = money(it.price * it.qty);
          row.appendChild(c2);
          totalRow.parentNode.insertBefore(row, totalRow);
        });
        var tCompare = tableBlock.querySelector('[data-mc-bundle-app-total-compare]');
        if (tCompare) tCompare.textContent = money(sum);
        var tPack = tableBlock.querySelector('[data-mc-bundle-app-total-pack]');
        if (tPack) tPack.textContent = money(packPrice);
        var sLabel = tableBlock.querySelector('[data-mc-bundle-app-save-label]');
        if (sLabel) sLabel.textContent = money(sum - packPrice) + ' · ' + pct + '%';
        var sFill = tableBlock.querySelector('[data-mc-bundle-app-save-fill]');
        if (sFill) sFill.style.width = Math.min(100, pct) + '%';
        tableBlock.removeAttribute('hidden');
      }
    }
  }

  function init() {
    var root = document.querySelector('[data-section-type="main-product-bundle-cervejas"]');
    if (!root || root.hasAttribute('data-mc-bundle-init')) return;
    root.setAttribute('data-mc-bundle-init', '');
    initGallery(root);
    initQtyTotal(root);
    initInCart(root);
    initBuyBar(root);
    initAppHydration(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
